module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-apache-03-m.d0577654d530cf20d8963a04eeaeb5bc.png";